import React from 'react';
import { HeaderGroup, TableInstance } from 'react-table';

interface ClientProfileModulesTableHeaderProps {
  table: TableInstance<any>;
}

const ClientProfileModulesTableHeader: React.FC<ClientProfileModulesTableHeaderProps> = ({ table }) => {
  const { headerGroups } = table;

  return (
    <thead className="bg-gray-100 dark:bg-gray-800">
      {headerGroups.map((headerGroup: HeaderGroup<any>) => (
        <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
          <th
            colSpan={headerGroup.headers.length}
            className="px-5 py-4 text-center text-sm font-bold text-gray-800 dark:text-gray-200 sm:text-base uppercase"
          >
            {headerGroup.headers[0].render('Header')}
          </th>
        </tr>
      ))}
    </thead>
  );
};

export default ClientProfileModulesTableHeader;
